<template>
  <div class="full flex column">
    <div class="hd flex-center column" style="height: 120px;">
      <div class="pt">设备总数</div>
      <count-to class="font-5x text-green" :start-val="lastTotalNum" :end-val="totalNum" />
    </div>
    <div class="bd">
      <div id="equip-stats-chart" class="full" style="height: 195px;" />
    </div>
  </div>
</template>

<script>
import { debounce } from '@/utils/common'
import { getEquipStatStatusApi } from '@/api/rms/rmsEquipStatApi'
export default {
  data() {
    return {
      totalNum: 0,
      onlineNum: 0,
      runningNum: 0,
      alarmNum: 0,

      lastTotalNum: 0,

      timerId: null,
      pingCounter: 0,
      pingCt: 5,

      statsChart: undefined,
      statsChartOption: {
        series: [
          {
            name: '在线',
            type: 'pie',
            radius: [44, 50],
            center: ['16%', '50%'],
            data: [{
              value: 0,
              itemStyle: {
                normal: {
                  color: '#007aff'
                }
              },
              label: {
                formatter: '{c}',
                position: 'center',
                textStyle: {
                  fontSize: '28'
                }
              }
            }, {
              value: 0,
              itemStyle: {
                normal: {
                  color: 'rgba(255,255,255,0.25)' // 背景圆环颜色
                }
              },
              label: {
                formatter: '\n{a}',
                position: 'center',
                textStyle: {
                  color: '#dddddd',
                  fontSize: '14'
                }
              }
            }],
            hoverAnimation: false
          }, {
            name: '运行',
            type: 'pie',
            radius: [44, 50],
            center: ['50%', '50%'],
            data: [{
              value: 0,
              itemStyle: {
                normal: {
                  color: '#07c160'
                }
              },
              label: {
                formatter: '{c}',
                position: 'center',
                textStyle: {
                  fontSize: '28'
                }
              }
            }, {
              value: 0,
              itemStyle: {
                normal: {
                  color: 'rgba(255,255,255,0.25)' // 背景圆环颜色
                }
              },
              label: {
                formatter: '\n{a}',
                position: 'center',
                textStyle: {
                  color: '#dddddd',
                  fontSize: '14'
                }
              }
            }],
            hoverAnimation: false
          }, {
            name: '告警',
            type: 'pie',
            radius: [44, 50],
            center: ['84%', '50%'],
            data: [{
              value: 0,
              itemStyle: {
                normal: {
                  color: '#f43530'
                }
              },
              label: {
                formatter: '{c}',
                position: 'center',
                textStyle: {
                  fontSize: '28'
                }
              }
            }, {
              value: 0,
              itemStyle: {
                normal: {
                  color: 'rgba(255,255,255,0.25)' // 背景圆环颜色
                }
              },
              label: {
                formatter: '\n{a}',
                position: 'center',
                textStyle: {
                  color: '#dddddd',
                  fontSize: '14'
                }
              }
            }],
            hoverAnimation: false
          }
        ]
      }
    }
  },

  created() {
    this.fetchStatsData()
    this.initInterval()
  },

  mounted() {
    this.initStatsChart()
    this.__resizeHandler = debounce(() => {
      if (this.statsChart) {
        this.statsChart.resize()
      }
    }, 100)
    window.addEventListener('resize', this.__resizeHandler)
  },

  beforeDestroy() {
    if (this.statsChart) {
      this.statsChart.dispose()
      this.statsChart = undefined
    }
    window.removeEventListener('resize', this.__resizeHandler)
    this.stopInterval()
  },

  methods: {
    initInterval() {
      var _this = this
      _this.pingCounter = 0
      _this.stopInterval()
      this.timerId = setInterval(function() {
        // 周期ping
        _this.pingCounter += 1
        if (_this.pingCounter >= _this.pingCt) {
          _this.pingCounter = 0
          _this.fetchStatsData(true)
        }
      }, 1000)
    },
    stopInterval() {
      if (this.timerId) {
        clearInterval(this.timerId)
        this.timerId = null
      }
    },


    updateData(data) {
      if (this.totalNum === data.total) {
        this.lastTotalNum = this.totalNum
        this.totalNum = data.total
        this.onlineNum = data.is_online
        this.runningNum = data.is_running
        this.alarmNum = data.is_alarm
        this.refreshStatsChart()
      } else {
        window.location.reload()
      }
    },


    fetchStatsData(ping) {
      getEquipStatStatusApi().then(res => {
        if (!res.errno) {
          if (ping && this.totalNum != res.data.total) {
            window.location.reload()
            return
          }
          this.lastTotalNum = this.totalNum
          this.totalNum = res.data.total
          this.onlineNum = res.data.is_online
          this.runningNum = res.data.is_running
          this.alarmNum = res.data.is_alarm

          this.refreshStatsChart()
        }
      })
    },

    initStatsChart() {
      this.statsChart = this.$echarts.init(document.getElementById('equip-stats-chart'), 'teenager')
      this.refreshStatsChart()

      // 点单击事件
      const _this = this
      this.statsChart.on('click', 'series', function(e) {
        const index = e.seriesIndex
        const statusMap = [3, 5, 4]
        _this.$router.push('/rms/equip?status=' + statusMap[index])
      })
    },

    refreshStatsChart() {
      this.statsChartOption.series[0].data[0].value = this.onlineNum
      this.statsChartOption.series[0].data[1].value = this.totalNum - this.onlineNum
      this.statsChartOption.series[1].data[0].value = this.runningNum
      this.statsChartOption.series[1].data[1].value = this.totalNum - this.runningNum
      this.statsChartOption.series[2].data[0].value = this.alarmNum
      this.statsChartOption.series[2].data[1].value = this.totalNum - this.alarmNum

      if (this.statsChart) {
        this.statsChart.setOption(this.statsChartOption)
      }
    },

    emit(oldVal, newVal) {
      this.$emit('equip-total-change', oldVal, newVal)
    }
  }
}
</script>
